import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Swal from "sweetalert2";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { map } from "lodash";

import { API_URL } from "helpers/app_url";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

const DealChecklist = props => {
  const [allConditions, setAllConditions] = useState([]);
  const [condition, setCondition] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    fetchConditions();
  }, []);

  const getTokenHeader = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return null;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return null;

    return {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    };
  };

  const fetchConditions = () => {
    const headers = getTokenHeader();
    if (!headers) return;

    axios
      .get(`${API_URL}ClientDealCheckList/allforagent`, {
        params: { agentId: parseInt(localStorage.getItem("userId")) },
        headers,
      })
      .then(res => setAllConditions(res.data))
      .catch(err => console.error("Error fetching checklist:", err));
  };

  const toggleCanvas = () => setIsRight(prev => !prev);

  const openEditCanvas = item => {
    setCondition({
      id: item.id,
      clientDealCheckListId: item.clientDealCheckListId,
      clientDealCheckListFor: item.clientDealCheckListFor,
      checkListTask: item.checkListTask,
      notificationsDays: item.notificationsDays,
      agentId: item.agentId,
      isActive: item.isActive,
    });
    setIsEdit(true);
    toggleCanvas();
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const headers = getTokenHeader();
    if (!headers) return;

    toast.loading("Please wait...");

    const payload = {
      checkListTask: values.checkListTask,
      clientDealCheckListFor: parseInt(values.clientDealCheckListFor, 10),
      notificationsDays: parseInt(values.notificationsDays, 10),
      displayOrder: 0,
      agentId: parseInt(values.agentId),
    };

    axios
      .post(`${API_URL}ClientDealCheckList`, payload, { headers })
      .then(res => {
        toast.dismiss();
        if (res.status === 200 && res.data.success) {
          toast.success("Saved successfully");
          fetchConditions();
          resetForm();
        } else {
          toast.warn(res.data.validationErrors?.[0] || "Save failed");
        }
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Something went wrong");
      })
      .finally(() => setSubmitting(false));
  };

  const handleUpdate = (values, { setSubmitting }) => {
    const headers = getTokenHeader();
    if (!headers) return;

    toast.loading("Please wait...");

    const payload = {
      id: values.id,
      clientDealCheckListId: values.clientDealCheckListId,
      checkListTask: values.checkListTask,
      clientDealCheckListFor: parseInt(values.clientDealCheckListFor, 10),
      notificationsDays: parseInt(values.notificationsDays, 10),
      displayOrder: 0,
      agentId: parseInt(values.agentId),
      isActive: values.isActive,
    };

    axios
      .put(`${API_URL}ClientDealCheckList`, payload, { headers })
      .then(res => {
        toast.dismiss();
        if (res.status === 200 && res.data.success) {
          toast.success("Updated successfully");
          fetchConditions();
          toggleCanvas();
        } else {
          toast.warn("Update failed");
        }
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Something went wrong");
      })
      .finally(() => setSubmitting(false));
  };

  const handleDelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This condition will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (!result.isConfirmed) return;

      const headers = getTokenHeader();
      if (!headers) return;

      axios
        .delete(`${API_URL}ClientDealCheckList/${id}`, { headers })
        .then(() => {
          fetchConditions();
          Swal.fire("Deleted!", "Deleted successfully.", "success");
        })
        .catch(() => {
          fetchConditions();
          Swal.fire("Deleted!", "DDeleted successfully.", "success");
        });
    });
  };

  const getApplicable = type => {
    if (type === 1) return "Buyer offer";
    if (type === 2) return "Seller offer";
    return "Buyer & seller offer";
  };

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />

      <div className="page-content">
       
        <Container fluid>
          <Row className="mb20">
            <Col xl="12">
              <Breadcrumbs title={props.t("General Settings")} breadcrumbItem={props.t("Deal Checklist")} />
            </Col>
          </Row>

          <Row>
           
            <Col xl="12">
              {/* CREATE FORM */}
              <Formik
                initialValues={{
                  checkListTask: "",
                  clientDealCheckListFor: "",
                  notificationsDays: "",
                  agentId: parseInt(localStorage.getItem("userId")),
                }}
                validationSchema={Yup.object({
                  checkListTask: Yup.string().required("Required"),
                  clientDealCheckListFor: Yup.string().required("Required"),
                  notificationsDays: Yup.string().required("Required"),
                })}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <Card>
                      <CardBody>
                        

                        <Row>
                          <Col sm="3">
                            <FormGroup>
                              <Label>Title *</Label>
                              <SafeField
                                name="checkListTask"
                                onChange={handleChange}
                                className={`form-control ${
                                  errors.checkListTask && touched.checkListTask ? "is-invalid" : ""
                                }`}
                              />
                              <ErrorMessage name="checkListTask" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>

                          <Col sm="3">
                            <FormGroup>
                              <Label>Applicable to *</Label>
                              <SafeField
                                name="clientDealCheckListFor"
                                as="select"
                                onChange={handleChange}
                                className={`form-control ${
                                  errors.clientDealCheckListFor && touched.clientDealCheckListFor ? "is-invalid" : ""
                                }`}
                              >
                                <option value="">Select</option>
                                <option value="1">Buyer offer</option>
                                <option value="2">Seller offer</option>
                                <option value="3">Buyer & seller offer</option>
                              </SafeField>
                            </FormGroup>
                          </Col>

                          <Col sm="3">
                            <FormGroup>
                              <Label>Due before closing *</Label>
                              <SafeField
                                name="notificationsDays"
                                as="select"
                                onChange={handleChange}
                                className={`form-control ${
                                  errors.notificationsDays && touched.notificationsDays ? "is-invalid" : ""
                                }`}
                              >
                                <option value="">Select</option>
                                {Array.from({ length: 15 }, (_, i) => i + 1).map(d => (
                                  <option key={d} value={d}>
                                    {d} {d === 1 ? "Day" : "Days"}
                                  </option>
                                ))}
                              </SafeField>
                            </FormGroup>
                          </Col>

                          <Col sm="2">
                            <Button type="submit" color="primary" style={{ marginTop: 31 }}>
                              Save
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>

              {/* LIST */}
              <Card>
                <CardBody>
                  <h5>History</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>#</th>  
                            <th>Title</th>
                            <th>Applicable to</th>
                            <th>Due before closing</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                      <tbody>
                        {map(allConditions, (c, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{c.checkListTask}</td>
                            <td>{getApplicable(c.clientDealCheckListFor)}</td>
                            <td>
                              {c.notificationsDays} {c.notificationsDays === 1 ? "Day" : "Days"}
                            </td>
                            <td>
                              <ActionEdit onClick={() => openEditCanvas(c)} />
                              <ActionDelete onClick={() => handleDelete(c.id)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* EDIT OFFCANVAS */}
          <Offcanvas isOpen={isRight} direction="end" toggle={toggleCanvas}>
            <OffcanvasHeader toggle={toggleCanvas}>Update</OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={condition}
                validationSchema={Yup.object({
                  checkListTask: Yup.string().required("Required"),
                  clientDealCheckListFor: Yup.string().required("Required"),
                  notificationsDays: Yup.string().required("Required"),
                })}
                onSubmit={handleUpdate}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <FormGroup>
                      <Label>Title *</Label>
                      <SafeField
                        name="checkListTask"
                        onChange={handleChange}
                        className={`form-control ${
                          errors.checkListTask && touched.checkListTask ? "is-invalid" : ""
                        }`}
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Applicable to *</Label>
                      <SafeField
                        name="clientDealCheckListFor"
                        as="select"
                        onChange={handleChange}
                        className={`form-control ${
                          errors.clientDealCheckListFor && touched.clientDealCheckListFor ? "is-invalid" : ""
                        }`}
                      >
                        <option value="">Select</option>
                        <option value="1">Buyer offer</option>
                        <option value="2">Seller offer</option>
                        <option value="3">Buyer & seller offer</option>
                      </SafeField>
                    </FormGroup>

                    <FormGroup>
                      <Label>Due before closing *</Label>
                      <SafeField
                        name="notificationsDays"
                        as="select"
                        onChange={handleChange}
                        className={`form-control ${
                          errors.notificationsDays && touched.notificationsDays ? "is-invalid" : ""
                        }`}
                      >
                        <option value="">Select</option>
                        {Array.from({ length: 15 }, (_, i) => i + 1).map(d => (
                          <option key={d} value={d}>
                            {d} {d === 1 ? "Day" : "Days"}
                          </option>
                        ))}
                      </SafeField>
                    </FormGroup>

                    <Button type="submit" color="primary">
                      Update
                    </Button>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};

DealChecklist.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withTranslation()(DealChecklist));
